import { render, staticRenderFns } from "./CertifikatJavno.vue?vue&type=template&id=af14a964&scoped=true&"
import script from "./CertifikatJavno.vue?vue&type=script&lang=js&"
export * from "./CertifikatJavno.vue?vue&type=script&lang=js&"
import style0 from "./CertifikatJavno.vue?vue&type=style&index=0&id=af14a964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af14a964",
  null
  
)

export default component.exports